import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { noop } from 'shell/utils/noop';
import { CertificatesAnpr } from 'shell/models/certificates-anpr';
import FormCertificatesAnpr, {
  CertificatesAnprForm,
} from 'system/components/certificates-anpr/form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonCertificatesAnprCrumbs } from '../constants';
import { transformerCertificatesAnpr } from 'system/components/certificates-anpr/utils/transformer-certificates';

const CertificatesAnprDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [certificate] = useHttpFetch<HttpResponse<CertificatesAnpr>, CertificatesAnprForm>(
    `${__MANAGEMENT_API_URL__}/postazione-anpr/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformerCertificatesAnpr,
    }
  );

  const navigate = useNavigate();

  const loadingCertificatesAnpr =
    certificate.isLoading || certificate.pristine || certificate.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonCertificatesAnprCrumbs,
          {
            name: 'Dettaglio Certificato postazione anpr',
          },
        ]}
      />
      {loadingCertificatesAnpr ? null : (
        <FormCertificatesAnpr
          title="Dettaglio Certificato postazione anpr"
          onOk={noop}
          onCancel={() => {
            navigate('/sistema/certificati-postazione');
          }}
          disabled
          initialValues={certificate.data as CertificatesAnprForm}
        ></FormCertificatesAnpr>
      )}
    </Fragment>
  );
};

CertificatesAnprDetailPage.displayName = 'Certificates Anpr Detail page component';

export default CertificatesAnprDetailPage;
